import * as React from "react";
import {isEmpty as _isEmpty} from "lodash"
import { IPatientAllergy } from "@curefit/ehr-common";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";

/**
 * Created by abhinav on 28/01/18.
 */

let AllergyEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "allergen", display: "ALLERGEN", mandatory: true},
    {label: "type", display: "TYPE", mandatory: true},
];


export interface PatientAllergyEditorProps {
    updatedAllergies: {item: IPatientAllergy}[],
    updateAllergies: (updatedAllergies: {item: IPatientAllergy}[]) => void;
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}

class PatientAllergyEditor extends React.Component<PatientAllergyEditorProps> {

    constructor(props: PatientAllergyEditorProps) {
        super(props);
    }

    onAllergyRemove = (index: number) => {
        let currUpdatedAllergies = Object.assign([], this.props.updatedAllergies);
        currUpdatedAllergies.splice(index, 1);
        this.props.updateAllergies(currUpdatedAllergies);
    }

    onAllergyChange = (updatedAllergy: IPatientAllergy, index: number) => {
        let currUpdatedAllergies = Object.assign([], this.props.updatedAllergies);
        currUpdatedAllergies[index] = updatedAllergy;
        this.props.updateAllergies(currUpdatedAllergies);
    }

    render() {
        return (
            <div className="patient-allergy-editor">
                {
                    !_isEmpty(this.props.questionnaire) &&
                    <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
                }
                <CustomHeader headerInfos={AllergyEditorHeaderInfos} rootCls={"patient-allergy"}/>
                <TemplatedList templateName={"allergy"} commonProps={{}}
                               defaultItem={{item: ModelFactory.createNewAllergy()}}
                               listItems={this.props.updatedAllergies}
                               onItemRemove={this.onAllergyRemove}
                               onItemChange={this.onAllergyChange}/>
            </div>
        );
    }
}

export default PatientAllergyEditor